import React from "react";
import { Link } from "react-router-dom";

const Sidebar = () => {
  return (
    <div className="sidebar">
      <div className="logo-container">
        <img src="/logo.png" alt="Logo" className="logo" />
      </div>
      <nav>
        <ul>
          <li><Link to="/home">Home</Link></li>
          <li><Link to="/portfolio">Portfolio</Link></li>
          <li><Link to="/crypto">Crypto Coins</Link></li>
          <li><Link to="/profile">Profile</Link></li>
          <li><Link to="/payment">Payment</Link></li>
          <li><Link to="/contactus">Contact Us</Link></li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
